import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight, Zap } from "lucide-react";
import { SectionHead } from "./SectionParts";
import { CategoryPill } from "./ArticleCard";

export default function ShortNews({ articles = [] }) {
  const ref = useRef(null);
  const items = articles.slice(0, 10);
  if (!items.length) return null;

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  return (
    <section className="my-16" data-testid="shortnews-section">
      <SectionHead
        title="60-सेकंड बोध"
        subtitle="कम शब्दों में पूरी खबर"
        icon={<Zap className="h-4 w-4" />}
        action={
          <div className="hidden md:flex gap-2">
            <button onClick={() => scroll(-1)} data-testid="short-prev" className="h-10 w-10 rounded-full border border-zinc-200 flex items-center justify-center hover:bodh-gradient hover:text-white transition">
              <ChevronLeft className="h-4 w-4" />
            </button>
            <button onClick={() => scroll(1)} data-testid="short-next" className="h-10 w-10 rounded-full border border-zinc-200 flex items-center justify-center hover:bodh-gradient hover:text-white transition">
              <ChevronRight className="h-4 w-4" />
            </button>
          </div>
        }
      />
      <div ref={ref} className="flex gap-4 overflow-x-auto pb-2 snap-x snap-mandatory scrollbar-thin" style={{ scrollbarWidth: "none" }}>
        {items.map((a) => (
          <Link
            key={a.id}
            to={`/article/${a.slug}`}
            data-testid={`short-card-${a.id}`}
            className="snap-start shrink-0 w-72 sm:w-80 rounded-2xl bg-white border border-zinc-100 shadow-sm hover:shadow-xl transition-all overflow-hidden group"
          >
            <div className="relative h-44 bg-zinc-100 overflow-hidden">
              {a.cover_image && (
                <img src={a.cover_image} alt={a.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700" />
              )}
              <div className="absolute top-3 left-3"><CategoryPill slug={a.category} /></div>
            </div>
            <div className="p-4">
              <h3 className="font-devanagari font-bold text-base leading-snug line-clamp-3 text-zinc-900">{a.title}</h3>
              {a.summary && <p className="mt-2 font-devanagari text-sm text-zinc-600 line-clamp-3">{a.summary}</p>}
              <div className="mt-3 flex items-center justify-between text-[11px] text-zinc-500 font-hind">
                <span>{a.author}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
